export const defaultNewsPreviewImage = {
  contentful_id: '3aOyAqoSNz5eW02mLXuiHC',
  __typename: 'ContentfulAsset',
  gatsbyImageData: {
    images: {
      sources: [
        {
          srcSet:
            'https://images.ctfassets.net/6d085vujy22q/3aOyAqoSNz5eW02mLXuiHC/b9e3cc83f3bcda20d145941e618a1f40/sezzle-og-image.jpg?w=362&h=181&q=50&fm=webp&fit=thumb&f=faces 362w,\nhttps://images.ctfassets.net/6d085vujy22q/3aOyAqoSNz5eW02mLXuiHC/b9e3cc83f3bcda20d145941e618a1f40/sezzle-og-image.jpg?w=724&h=362&q=50&fm=webp&fit=thumb&f=faces 724w',
          sizes: '362px',
          type: 'image/webp',
        },
      ],
      fallback: {
        src: 'https://images.ctfassets.net/6d085vujy22q/3aOyAqoSNz5eW02mLXuiHC/b9e3cc83f3bcda20d145941e618a1f40/sezzle-og-image.jpg?w=362&h=181&fl=progressive&q=50&fm=jpg&fit=thumb&f=faces',
        srcSet:
          'https://images.ctfassets.net/6d085vujy22q/3aOyAqoSNz5eW02mLXuiHC/b9e3cc83f3bcda20d145941e618a1f40/sezzle-og-image.jpg?w=362&h=181&fl=progressive&q=50&fm=jpg&fit=thumb&f=faces 362w,\nhttps://images.ctfassets.net/6d085vujy22q/3aOyAqoSNz5eW02mLXuiHC/b9e3cc83f3bcda20d145941e618a1f40/sezzle-og-image.jpg?w=724&h=362&fl=progressive&q=50&fm=jpg&fit=thumb&f=faces 724w',
        sizes: '362px',
      },
    },
    layout: 'fixed',
    backgroundColor: '#482878',
    width: 362,
    height: 181,
  },
};
